import type { TokenObtain, TokenObtainResponse } from '~/api/generated';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    access: null as string | null,
    refresh: null as string | null
  }),
  getters: {
    isLoggedIn: (state) => !!state.access
  },
  actions: {
    getTokens(requestBody: TokenObtain) {
      const apiStore = useApiStore();

      return apiStore.api.auth.authTokenCreate({ requestBody });
    },

    setTokens(tokens: TokenObtainResponse) {
      this.access = tokens.access;
      this.refresh = tokens.refresh;
    },

    async refreshTokens() {
      const apiStore = useApiStore();

      const { access, refresh } = await apiStore.api.auth.authTokenRefreshCreate({
        requestBody: { refresh: this.refresh as string }
      });

      if (access && refresh) {
        this.setTokens({ access, refresh });

        apiStore.setToken(access);
      }
    },

    async login(tokens: TokenObtainResponse) {
      const apiStore = useApiStore();

      this.setTokens(tokens);

      apiStore.setToken(tokens.access as string);

      await this.getAppData();
    },

    async logout() {
      const { query } = useRoute();

      const router = useRouter();

      this.resetAppData();

      await router.replace({ name: 'login', query });
    },

    async getAppData() {
      const userStore = useUserStore();
      const sessionStore = useSessionStore();
      const formatStore = useFormatStore();
      const doctorSpecialityStore = useDoctorSpecialityStore();
      const promptTemplateStore = usePromptTemplateStore();
      const dignitiesStore = useDignitiesStore();
      const billingCodesStore = useBillingCodesStore();

      await userStore.getUser();
      await sessionStore.getSessions();
      await formatStore.getFormats();
      await doctorSpecialityStore.getDoctorSpecialities();
      await promptTemplateStore.getPromptTemplates();
      await dignitiesStore.getDignities();
      await billingCodesStore.getBillingCodes();
    },

    resetAppData() {
      const apiStore = useApiStore();
      const userStore = useUserStore();
      const sessionStore = useSessionStore();
      const formatStore = useFormatStore();
      const doctorSpecialityStore = useDoctorSpecialityStore();
      const promptTemplateStore = usePromptTemplateStore();
      const dignitiesStore = useDignitiesStore();
      const billingCodesStore = useBillingCodesStore();
      const recordingUploadStore = useRecordingUploadStore();

      this.$reset();
      apiStore.$reset();
      userStore.$reset();
      sessionStore.$reset();
      formatStore.$reset();
      doctorSpecialityStore.$reset();
      promptTemplateStore.$reset();
      dignitiesStore.$reset();
      billingCodesStore.$reset();
      recordingUploadStore.$reset();
    }
  },
  persist: {
    storage: persistedState.localStorage
  }
});
